module.exports = __webpack_public_path__ + "img/rossi.8dd45db0.jpeg";